/** Clinician-set gate for auto-publish vs review queue. Adjust only after clinical review. */
export const CONFIDENCE_THRESHOLD = 0.85;
